<div class="loginBody">
    <div class="loginBody-content">
        <h1 class="loginTitle">
            {{ 'MODULES.LOGIN.SIGNIN_HEADER' | transloco }}
        </h1>
        <ng-container *ngIf="isCasinoAccVerfication">
            <h2 class="loginHeader">
                {{ 'MODULES.LOGIN.CASINO_ACC_SUBHEADER' | transloco }}
            </h2>
            <div class="vjLoggedIn">
                <div class="vjLoggedIn_profile">
                    <figure class="dsProfile dsProfile-T1">
                        <!-- <img class="dsProfile_img" src="src/resources/images/avatar.svg " alt="Profile Image" /> -->
                        <span>T1</span>
                    </figure>
                    <div>
                        <p>{{ 'MODULES.LOGIN.LOGGED_IN_AS' | transloco }}</p>
                        <h4 class="vjLoggedIn_profile_name">Tier 1</h4>
                    </div>
                </div>
                <div class="vjLoggedIn_signout">
                    <p>
                        {{ 'MODULES.LOGIN.NOT_YOU' | transloco }}
                        <a class="dsLink"><span class="dsLink_line">{{ 'MODULES.LOGIN.SIGN_OUT' | transloco }}</span></a>
                    </p>
                </div>
            </div>
        </ng-container>
        <!-- otp -->
    <div class="vjOTPVerfication">
        <h4>{{ 'MODULES.LOGIN.OTP_VERIFICATION' | transloco }}</h4>
        <p>{{ 'MODULES.LOGIN.OTP_SENT_TO_EMAIL' | transloco }}</p>
        <p class="vjOTPVerfication_mail"><b>{{ mailId }}</b><i class="icon-edit"></i></p>
        <div class="vjOTPVerfication_otp">
            <div class="dsFieldWrap">
                <mat-form-field>
                <input matInput maxlength="1"/>
                </mat-form-field>
                <mat-form-field>
                <input matInput maxlength="1"/>
                </mat-form-field>
                <mat-form-field>
                <input matInput maxlength="1"/>
                </mat-form-field>
                <mat-form-field>
                <input matInput maxlength="1"/>
                </mat-form-field>
                <mat-form-field>
                <input matInput maxlength="1"/>
                </mat-form-field>
                <mat-form-field>
                <input matInput maxlength="1"/>
                </mat-form-field>
            </div>
        </div>
    </div>
    </div>
    <footer class="loginBody-footer">
        <ng-container *ngIf="!isCasinoAccVerfication">
            <button class="loginAction_btn">{{ 'MODULES.LOGIN.CONFIRM' | transloco }}</button>
            <div class="login-options">
                <div class="login-options-link">
                    <span>{{ 'MODULES.LOGIN.DIDNT_RECEIVE_CODE' | transloco }}</span>
                    <a class="dsLink"><span class="dsLink_line">{{ 'MODULES.LOGIN.RESEND' | transloco }}</span></a>
                </div>
            </div>
        </ng-container>
        <ng-container *ngIf="isCasinoAccVerfication">
            <button class="loginAction_btn">{{ 'MODULES.LOGIN.VERIFY' | transloco }}</button>
            <button class="loginAction_btn loginAction_btn-def">{{ 'MODULES.LOGIN.CANCEL' | transloco }}</button>
            <div class="login-options">
                <div class="login-options-link">
                    <span>{{ 'MODULES.LOGIN.DIDNT_RECEIVE_CODE' | transloco }}</span>
                    <a class="dsLink"><span class="dsLink_line">{{ 'MODULES.LOGIN.RESEND' | transloco }}</span></a>
                </div>
            </div>
        </ng-container>
        <div class="login-copyright">© {{ currentYear }} Light & Wonder, Inc. and its Subsidiaries. All rights reserved
        </div>
    </footer>
</div>